export const qaEnvironment: boolean = (window as any).clutter.qaEnvironment;
